/**
 * src/config/app.config.ts
 * Central application configuration.
 */

export const APP_CONFIG = {
  /**
   * Path to the organisation logo. The file must be placed at /public/logo.png.
   * Used in the NavBar, every page header, and the cover page.
   */
  logoPath: "/logo.png",

  /** Copyright line shown in regular page footers. */
  copyright: (import.meta.env.VITE_COMPANY_COPYRIGHT as string | undefined)
    ?? "© 2025 Mon Organisation · Tous droits réservés",

  /** Company address shown in the cover page footer band. */
  companyAddress: (import.meta.env.VITE_COMPANY_ADDRESS as string | undefined) ?? "",

  /** Base URL of the backend API (Vite proxies /api → localhost:3001 in dev). */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api",

  /** Base URL of ts-ingest — timeseries process indépendant de l'API principale (Vite proxies /ts → localhost:3003 in dev, cf. docs/ts-ingest/ts-ingest.md). */
  tsIngestBaseUrl: (import.meta.env.VITE_TS_INGEST_BASE_URL as string | undefined) ?? "/ts",

  /**
   * Active l'intégration SharePoint (upload depuis ReportViewer + page Documents).
   * Mettre à `false` pour masquer complètement ces fonctionnalités sans toucher au code.
   */
  sharepointEnabled: (import.meta.env.VITE_SHAREPOINT_ENABLED as string | undefined) !== "false",
} as const;
